import * as React from 'react'
import styled, { keyframes } from 'styled-components'
import { theme } from 'utils/styledHelper'

const bounceAnimation = keyframes`
  0%,
  100% { transform: scale(0); }
  50% { transform: scale(1); }
`

const Container = styled.div<PropsType>`
  position: relative;
  width: ${(p) => p.size ?? '40px'};
  height: ${(p) => p.size ?? '40px'};
`

const Circle1 = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  opacity: 0.7;
  background-color: ${theme('loaderColor')};
  animation: ${bounceAnimation} 2s infinite ease-in-out;
`

const Circle2 = styled(Circle1)`
  animation-delay: -1s;
`

type PropsType = { className?: string; size?: string }

const HeartbeatLoader = (props: PropsType) => (
  <Container {...props}>
    <Circle1 />
    <Circle2 />
  </Container>
)

export default HeartbeatLoader
